import { createIntl, createIntlCache } from 'react-intl';
import translations from '~/infra/i18n/locales';
import { getLocale } from '~/utils/getLocale';
import { CreateOrganizer } from '~/domain/usecases/organizer/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
  Conflict,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';
import { AlertMessage } from '~/presentation/components/messages/AlertMessage';
import { translator } from '~/presentation/components/i18n';

const cache = createIntlCache();

const intl = createIntl(
  {
    locale: String(getLocale()),
    messages: translations[getLocale()],
  },
  cache,
);

export class RemoteCreateOrganizer implements CreateOrganizer {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateOrganizer.Model>;

  constructor(url: string, httClient: HttpClient<CreateOrganizer.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  create = async (
    params: CreateOrganizer.Params,
  ): Promise<CreateOrganizer.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        AlertMessage({
          type: 'danger',
          message: intl.formatMessage({ id: 'Falha ao registrar usuário.' }),
        });
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
      case HttpStatusCode.forbidden:
        AlertMessage({
          type: 'danger',
          message: intl.formatMessage({ id: 'Falha ao registrar usuário.' }),
        });
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        AlertMessage({
          type: 'danger',
          message: intl.formatMessage({ id: 'Falha ao registrar usuário.' }),
        });
        throw new NotFound();
      case HttpStatusCode.conflict:
        AlertMessage({
          type: 'danger',
          message: intl.formatMessage({ id: 'E-mail ou CPF já utilizado.' }),
        });
        throw new Conflict();
      default:
        AlertMessage({
          type: 'danger',
          message: intl.formatMessage({ id: 'Falha ao registrar usuário.' }),
        });
        throw new UnexpectedError();
    }
  };
}
